export const name = '_chainlink'
export const displayName = 'Chainlink'
export const ticker = `${name}_LINK`
export const displayTicker = 'LINK'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 6,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'chainlink',
  'link_matic_0fc0671d',
  'link_ethereumarbone_63f7deae',
]
